var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-content",class:[..._setup.cssClasses]},[(_vm.loading)?_c('div',{staticClass:"container-loading"},[_c('div',{staticClass:"loading"},[_c(_setup.GrSpinner)],1)]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }